import { NONAME } from "dns";
export var schema = {
  title: "Geyser",
  description: "Geyser form",
  type: "object",
  properties: {
    info: {
      type: "object",
      title: "Information",
      required: ["region", "insuredPolicyNumber", "insuredName", "insuredtel", "clientEmail", "brokerage", "brokeremail", "claimtypeCat", "claimtype"],
      properties: {
        region: {
          type: "string",
          title: "Region",
          enum: ["Gauteng", "Cape Town"]
        },
        insuredPolicyNumber: {
          type: "string",
          title: "Policy Number"
        },
        insuredName: {
          type: "string",
          title: "Insured Name and Surname"
        },
        insuredtel: {
          type: "string",
          title: "Insured Contact Number",
          minLength: 10
        },
        clientEmail: {
          type: "string",
          title: "Insured Email",
          format: "email"
        },
        brokerage: {
          type: "string",
          title: "Brokerage"
        },
        brokerName: {
          type: "string",
          title: "Broker Contact Person"
        },
        brokeremail: {
          type: "string",
          title: "Broker Email",
          format: "email"
        },
        claimtypeCat: {
          type: "string",
          title: "What type of incident you want to submit claim for?",
          enum: ["Motor", "Non-motor"]
        },
        claimtype: {
          type: "string",
          title: "Item you want to submit claim for"
        },
        claimMotor: {
          type: "string",
          title: "Motor item you want to submit claim for",
          enum: ["Motor Vehicle Windscreen", "Vehicle Stolen or Hijacked", "Accident Collision"]
        },
        claimNonMotor: {
          type: "string",
          title: "Non-motor item you want to submit claim for",
          enum: ["Geyser", "Property Loss or Damage", "Public Liability"]
        }
      },
      dependencies: {
        claimMotor: {
          oneOf: [{
            properties: {
              claimMotor: {
                enum: ["Accident Collision"]
              },
              thirdparty: {
                type: "object",
                title: "Third Party",
                required: ["thirdpartyInvolved"],
                properties: {
                  thirdpartyInvolved: {
                    type: "string",
                    title: "Was there a Third Party Involved in the Incident?",
                    enum: ["Yes", "No"]
                  }
                },
                dependencies: {
                  thirdpartyInvolved: {
                    oneOf: [{
                      properties: {
                        thirdpartyInvolved: {
                          enum: ["Yes"]
                        },
                        thirdpartyOther: {
                          type: "object",
                          title: "",
                          required: ["thirdpartyHaveDetails"],
                          properties: {
                            thirdpartyHaveDetails: {
                              type: "string",
                              title: "Do you have Third Party Details?",
                              enum: ["Yes", "No"]
                            }
                          },
                          dependencies: {
                            thirdpartyHaveDetails: {
                              oneOf: [{
                                properties: {
                                  thirdpartyHaveDetails: {
                                    enum: ["No"]
                                  },
                                  thirdpartyHaveDetailsNote: {
                                    type: "null",
                                    title: "When you receive third party information, please submit to your broker as it's required for claim processing."
                                  }
                                }
                              }, {
                                properties: {
                                  thirdpartyHaveDetails: {
                                    enum: ["Yes"]
                                  }
                                }
                              }]
                            }
                          }
                        }
                      }
                    }, {
                      properties: {
                        thirdpartyInvolved: {
                          enum: ["No"]
                        }
                      }
                    }]
                  }
                }
              }
            }
          }]
        }
      }
    },
    incident: {
      type: "object",
      title: "Incident",
      required: ["insureddateloss", "incidentAddress", "incidentDescription", "incidentburstgeyser", "incidentgeysersize", "incidentOtherPolicy"],
      properties: {
        insureddateloss: {
          type: "string",
          title: "Date and Time When Incident Occurred?",
          format: "date-time"
        },
        incidentsection: {
          type: "string",
          title: "Section/Unit Number"
        },
        incidentAddress: {
          type: "string",
          title: "Address Where Incident Occurred?"
        },
        incidentLat: {
          type: "string",
          title: "Latitude"
        },
        incidentLong: {
          type: "string",
          title: "Longitude"
        },
        incidentDescription: {
          type: "string",
          title: "Description of What Occurred?"
        },
        incidentburstgeyser: {
          type: "string",
          title: "Burst Geyser",
          enum: ["Yes", "No"]
        },
        incidentgeysersize: {
          type: "string",
          title: "Size of Geyser",
          enum: ["50 Litre", "100 Litre", "150 Litre", "200 Litre", "300 Litre", "500 Litre", "Other"]
        },
        incidentDamages: {
          type: "object",
          title: "",
          required: ["incidentResultantDamage"],
          properties: {
            incidentResultantDamage: {
              type: "string",
              title: "Is there a Resultant Damage(s)?",
              enum: ["Yes", "No"]
            }
          },
          dependencies: {
            incidentResultantDamage: {
              oneOf: [{
                properties: {
                  incidentResultantDamage: {
                    enum: ["Yes"]
                  },
                  incidentResultantDamageOptions: {
                    type: "object",
                    title: "",
                    properties: {
                      floors: {
                        type: "boolean",
                        title: "Floors"
                      },
                      carpets: {
                        type: "boolean",
                        title: "Carpets"
                      },
                      ceilings: {
                        type: "boolean",
                        title: "Ceilings"
                      },
                      cupboards: {
                        type: "boolean",
                        title: "Cupboards"
                      },
                      other: {
                        type: "boolean",
                        title: "Other"
                      }
                    }
                  }
                }
              }, {
                properties: {
                  incidentResultantDamage: {
                    enum: ["No"]
                  }
                }
              }]
            }
          }
        },
        incidentOtherPolicy: {
          type: "string",
          title: "Is this Incident Covered Under Any Other Policy of Insurance?",
          enum: ["Yes", "No"]
        }
      }
    },
    attachments: {
      type: "object",
      title: "Attachments",
      description: "Please Add Any Pictures of the Geyser and Resultant Damages.",
      properties: {
        attachmentsList: {
          title: "Attachments",
          type: "array",
          description: "File Names Should Not Have Any Round Brackets. ()",
          items: {
            type: "object",
            properties: {
              attachment: {
                type: "array",
                title: "Attachment",
                items: [{
                  key: "attachName",
                  title: "Title",
                  type: "string",
                  maxLength: 200
                }, {
                  key: "attachmentContent",
                  type: "array",
                  title: "Attachment",
                  items: {
                    type: "string",
                    format: "data-url"
                  }
                }]
              }
            }
          }
        }
      }
    },
    declaration: {
      type: "object",
      title: "Declaration",
      required: ["insuredaccepttc"],
      description: "I/we declare that to the best of my/our knowledge the above statements are true. I acknowledge that the information set out above is provided freely so that Western may process my claim and give effect to the terms and conditions contained in the policy wording. I herewith give my consent that Western may use this information, my personal information on record and additional information obtained from other sources in order to determine whether to accept or reject my claim and take all necessary steps ancillary thereto to give effect hereto. I understand that I may be liable for output VAT in terms of section 8(8) of the VAT Act 89 of 1991.",
      properties: {
        insuredaccepttc: {
          type: "boolean",
          title: "Accept Terms and Conditions",
          description: "Tick Box to Accept Terms and Conditions"
        },
        insuredcapcity: {
          type: "string",
          title: "Capacity"
        },
        insureddate: {
          type: "string",
          title: "Date",
          format: "date"
        }
      }
    }
  }
};
export var uiSchema = {
  claimMotor: {
    classNames: "hidden"
  },
  claimNonMotor: {
    classNames: "hidden"
  },
  incidentLat: {
    "ui:widget": "hidden"
  },
  incidentLong: {
    "ui:widget": "hidden"
  },
  incidentDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  }
};